export default __webpack_public_path__ + "static/media/Arena.a7ff123f.svg";